import React from 'react'


// TODO: fill this in!
export default function BuySmsCredits() {
  return <div>Please contact customer support for instructions on how to buy SMS Credits</div>
}
